import React, { useEffect } from 'react';
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import * as CookieConsent from 'vanilla-cookieconsent';

const CookieConsentComponent: React.FC = () => {
  useEffect(() => {
    CookieConsent.run({
      onConsent: ({cookie}) => {
        if (cookie.categories.includes('analytics')) {
          // Réactiver Matomo si les cookies analytics sont acceptés
          if (window._paq) {
            window._paq.push(['rememberConsentGiven']);
            window._paq.push(['trackPageView']);
          }
        }
      },
      onChange: ({cookie, changedCategories}) => {
        if (changedCategories.includes('analytics')) {
          if (cookie.categories.includes('analytics')) {
            // Analytics acceptées
            if (window._paq) {
              window._paq.push(['rememberConsentGiven']);
            }
          } else {
            // Analytics refusées
            if (window._paq) {
              window._paq.push(['forgetConsentGiven']);
            }
          }
        }
      },
      guiOptions: {
        consentModal: {
          layout: 'box',
          position: 'bottom right',
          equalWeightButtons: true,
          flipButtons: false
        },
        preferencesModal: {
          layout: 'box',
          position: 'right',
          equalWeightButtons: true,
          flipButtons: false
        }
      },
      categories: {
        necessary: {
          readOnly: true
        },
        analytics: {}
      },
      language: {
        default: 'fr',
        translations: {
          fr: {
            consentModal: {
              title: 'Nous utilisons des cookies',
              description: 'Ce site utilise des cookies pour améliorer votre expérience. Certains cookies sont nécessaires au fonctionnement du site, tandis que d\'autres nous aident à comprendre comment vous utilisez notre site.',
              acceptAllBtn: 'Accepter tout',
              acceptNecessaryBtn: 'Accepter les nécessaires',
              showPreferencesBtn: 'Gérer les préférences',
              footer: '<a href="/mentions-legales">Mentions légales</a>\n<a href="/politique-confidentialite">Politique de confidentialité</a>'
            },
            preferencesModal: {
              title: 'Préférences de cookies',
              acceptAllBtn: 'Accepter tout',
              acceptNecessaryBtn: 'Accepter les nécessaires',
              savePreferencesBtn: 'Sauvegarder les préférences',
              closeIconLabel: 'Fermer',
              serviceCounterLabel: 'Service|Services',
              sections: [
                {
                  title: 'Utilisation des cookies',
                  description: 'Nous utilisons des cookies pour améliorer votre expérience sur notre site. Vous pouvez choisir quels types de cookies vous souhaitez autoriser.'
                },
                {
                  title: 'Cookies nécessaires <span class="pm__badge">Toujours activés</span>',
                  description: 'Ces cookies sont nécessaires au fonctionnement du site et ne peuvent pas être désactivés.',
                  linkedCategory: 'necessary'
                },
                {
                  title: 'Cookies d\'analyse',
                  description: 'Ces cookies nous aident à comprendre comment vous utilisez notre site pour l\'améliorer.',
                  linkedCategory: 'analytics'
                }
              ]
            }
          }
        }
      }
    });
  }, []);

  return null;
};

export default CookieConsentComponent;